import React, { FC, ReactNode } from "react";
import { StyledLayout } from "./index.styled";

interface AuthPageContentLayoutProps {
  children: ReactNode;
  inModal?: boolean;
}

/**
 * Layout component for public authentication pages (login, signup, etc.)
 * @param children - The content to render inside the layout
 * @param inModal - Whether the layout is rendered inside a modal
 * @returns The layout component
 */
export const AuthPageContentLayout: FC<AuthPageContentLayoutProps> = ({
  children,
  inModal = false,
}) => {
  return <StyledLayout inModal={inModal}>{children}</StyledLayout>;
};
